export const fileTracker = {
  actions: {
    downloadPDF: 'Baixar PDF',
    downloadFile: 'Download de arquivo',
  },
}
